export default __webpack_public_path__ + "static/media/raki_detail8.7f597227.jpg";